<template>
  <div class="m-b-20 s_flex_ali">
    <div class="p-r-15 width-140">
      <a-button :type="action == 1 ? 'primary':''" block @click='typeCheck(1)'>发放明细</a-button>
    </div>
    <div class="p-r-15 width-140">
      <a-button :type="action == 2 ? 'primary':''" block @click='typeCheck(2)'>消耗明细</a-button>
    </div>
     <div class="p-r-15 width-140">
      <a-button :type="action == 3 ? 'primary':''" block @click='typeCheck(3)'>清理明细</a-button>
    </div>
  </div>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="时间" name='month'>
      <!-- {{search.month}} -->
      <a-month-picker v-model:value="search.month" format="YYYY-MM" valueFormat='YYYY-MM' @change="changeTime" />
    </a-form-item>
    <a-form-item label="发放渠道" name='type'  v-if="action!=3">
      <a-select v-model:value="search.type" :style="{width:'180px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="1" v-show='search.action == 1'>会员权益</a-select-option>
        <a-select-option :value="2">{{search.action == 1 ? '直接发放':'直接扣除'}}</a-select-option>
        <a-select-option :value="3" v-show='search.action == 1'>扫码活动</a-select-option>
        <a-select-option :value="4" v-show='search.action == 1'>会员任务</a-select-option>
        <a-select-option :value="5">云店购物</a-select-option>
        <a-select-option :value="6">拼团活动</a-select-option>
        <a-select-option :value="7">秒杀活动</a-select-option>
        <a-select-option :value="8" v-show='search.action == 1'>团长积分</a-select-option>
        <a-select-option :value="9" v-show='search.action == 2'>门店核销</a-select-option>
        <a-select-option :value="10" v-show='search.action == 2'>积分商城</a-select-option>
        <a-select-option :value="13" v-show='search.action == 1'>夺宝失败</a-select-option>
        <a-select-option :value="15" v-show='search.action == 1'>首页优惠礼包</a-select-option>
        <a-select-option :value="16" v-show='search.action ==2'>积分清理</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="关键词" name='keyword'>
      <a-input v-model:value="search.keyword" :style="{width:'250px'}" placeholder="请输入用户ID/用户昵称"></a-input>
    </a-form-item>
    <!-- 门店筛选 -->
    <a-form-item label="消费门店" name='store_name' v-if='action == 2'>
      <a-input v-model:value="search.store_name" :style="{width:'220px'}" placeholder="请选择消费门店" readonly></a-input>
       <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 50%;transform:translateY(-50%)" v-if='search.store_name' @click='search.store_name="";search.store_id="";storeData={}' />
    </a-form-item>
    <a-form-item v-if='action == 2'>
        <a-button type="primary"  @click="showStore=true">选择</a-button>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
      <a-button type="primary" ghost class="m-l-15" v-show="search.action==1" v-has:pointsDistributionExport="()=>{exportTable()}">导出</a-button>
      <a-button type="primary" ghost class="m-l-15" v-show="search.action==2" v-has:pointsDistributionExport="()=>{exportTable()}">导出</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <!--  -->
  <a-modal :keyboard="false" title="选择消费门店" centered v-model:visible="showStore" :width='1200' :footer="null" destroyOnClose>
       <selectStore v-on:select="storeSelect" :selectList='[{id:storeData.id}]' :checkout='false' :canCancel="false" :hiddenHead='true'></selectStore>
    </a-modal>

</template>
<script>
import { reactive, ref, toRefs } from "vue";
import { CloseCircleFilled } from "@ant-design/icons-vue";
import { getIntegralPointLog } from "@/api/assets";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  keyword: "",
  type: "",
  page: 1,
  limit: 10,
  month: "",
  action: 1,
  store_name:'',
  store_id:'',
};
export default {
  name: "integralDetail",
  components:{CloseCircleFilled},
  setup() {
    const search = ref({ ...defSearch });
    const state = reactive({
      listLoading: false,
      total: 0,
      showStore:false,
      storeData:{},
      action:1,
      columns: [
        {
          title: "用户ID",
          dataIndex: "user_id",
          key: "user_id",
          customRender: ({ record }) => {
            return record.user_id ? record.user_id : "-";
          },
        },
        {
          title: "用户昵称",
          dataIndex: "nickname",
          key: "nickname",
          customRender: ({ record }) => {
            return record.nickname ? record.nickname : "-";
          },
        },
        {
          title: "发放渠道",
          dataIndex: "type_text",
          key: "type_text",
        },
        {
          title: "积分数量",
          dataIndex: "point",
          key: "point",
        },
        {
          title: "日期",
          dataIndex: "create_time",
          key: "create_time",
        },
      ],
    });
    const data = ref();
    //获取列表
    const initData = async (values) => {
      state.listLoading = true;
      data.value = [];
      state.total = 0;
      let res = await getIntegralPointLog(values).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data.data;
        state.total = res.data.total;
      }
      state.listLoading = false;
    };
    // 发放/消耗切换
    const typeCheck = (e) => {
      if (e == 1) {
        state.columns.splice(4, 1)
      } else if(e==2){
        state.columns = [
          {
            title: "用户ID",
            dataIndex: "user_id",
            key: "user_id",
            customRender: ({ record }) => {
              return record.user_id ? record.user_id : "-";
            },
          },
          {
            title: "用户昵称",
            dataIndex: "nickname",
            key: "nickname",
            customRender: ({ record }) => {
              return record.nickname ? record.nickname : "-";
            },
          },
          {
            title: "发放渠道",
            dataIndex: "type_text",
            key: "type_text",
          },
          {
            title: "积分数量",
            dataIndex: "point",
            key: "point",
          },
          {
            title: "消费门店",
            dataIndex: "store_name",
            key: "store_name",
            customRender: ({ record }) => {
              return record.store_name ? record.store_name : "-";
            },
          },
          {
            title: "日期",
            dataIndex: "create_time",
            key: "create_time",
          },
        ];
      }else{
        state.columns = [
          {
            title: "用户ID",
            dataIndex: "user_id",
            key: "user_id",
            customRender: ({ record }) => {
              return record.user_id ? record.user_id : "-";
            },
          },
          {
            title: "用户昵称",
            dataIndex: "nickname",
            key: "nickname",
            customRender: ({ record }) => {
              return record.nickname ? record.nickname : "-";
            },
          },
          {
            title: "积分数量",
            dataIndex: "point",
            key: "point",
          },
          {
            title: "日期",
            dataIndex: "create_time",
            key: "create_time",
          },
        ];
      }
      // 积分清理和积分消耗明细 action 都为2 
      search.value.action = e==1?1:2  
      state.action=e
      // 积分清理时清理 type=16 其余为空
      search.value.type=e==3?16:''
      initData({
        ...search.value,
        page: 1,
        keyword: "",
        type: "",
        month: ""
      });
    };
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    initData(search.value);
    const changeTime = (e) => {
      if (!e) {
        search.value.month = "";
        return;
      }
      search.value.month = e;
    };

    const storeSelect = (val)=>{
      console.log(val)
        state.storeData = val || {id:null}
        search.value.store_name = state.storeData.store_name || '';
        search.value.store_id = state.storeData.id || '';
        state.showStore = false
    }

    const exportTable =async function(){
            // 积分清理和积分消耗明细 action 都为2 
      search.value.action = state.action==1?1:2  
      // 积分清理时清理 type=16 其余为空
      search.value.type=state.action==3?16:''
      let result=await getIntegralPointLog({...search.value,excel:1}).then(res=>res.data).catch(error=>error)
           if(iscode(result,true)){
             window.open(result.data.action)
      }
    }
    return {
      ...toRefs(state),
      search,
      data,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      typeCheck,
      changeTime,
      storeSelect,
      exportTable
    };
  },
};
</script>